var React = require('react');

function RexHome (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.326 16.225c.733 0 1.326-.595 1.326-1.324V8.304l4.331-2.597 4.5 2.957c.61.4 1.432.23 1.835-.38a1.322 1.322 0 00-.378-1.832l-4.779-3.134a2.304 2.304 0 00-2.359.011L3.112 6.143A2.292 2.292 0 002 8.095V14.9c0 .732.593 1.324 1.326 1.324zm9.863-.31c2.856 0 4.429-1.815 4.496-1.893a1.321 1.321 0 00.17-1.464 1.319 1.319 0 00-1.287-.715 1.311 1.311 0 00-.898.458l-.002.002c-.049.052-.913.964-2.48.964-1.6 0-2.49-.94-2.526-.98a1.33 1.33 0 00-2.18.29 1.323 1.323 0 00.19 1.459c.068.075 1.677 1.88 4.517 1.88z","fill":"currentColor"}));
}

RexHome.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = RexHome;

RexHome.default = RexHome;
